import MainPage from '@/screens/relatorios_reurb/MainPage'
import { items } from '@/screens/relatorios_reurb/config.js'

const relatoriosReurb = [
  {
    path: '/relatoriosreurb',
    name: 'relatoriosreurb',
    component: MainPage,
    children: [...items]
  }
]

export default relatoriosReurb



// WEBPACK FOOTER //
// ./src/router/relatorios_reurb.js